export const MIN_SALARY = 1;
export const MAX_SALARY = 999999;
export const AGE_LIMIT = {
  MIN: 23,
  MAX: 65,
};
export const ELIGIBLE_PARTNERS = [
  'RBL',
  'DMI',
  'INCRED',
  'FULLERTON',
  'HDBFS',
  'CREDITSAISON',
  'LENDBOX',
  'ASPIRE',
  'KOMAC',
  'TRILLIONLOANS',
];
export const ELIGIBLE_LINE_TYPES = ['CASH_LINE'];
export const LINE_TYPES = {
  CF: 'CONSUMER_FINANCE',
  CL: 'CASH_LINE',
  FC: 'FAST_CASH',
};
export const SALARY_LIMITS = {
  MIN: 25000,
};
export const AIP_LINE_ELIGIBLE_PARTNERS = [
  'DMI',
  'RBL',
  'INCRED',
  'FULLERTON',
  'TAPSTART',
  'CREDITSAISON',
  'HDBFS',
  'MUSKMELON',
  'LENDBOX',
  'CHOLAMANDALAM',
  'ASPIRE',
  'KOMAC',
  'TRILLIONLOANS',
];

export const IMPS_ELIGILBLE_PARTNERS = [
  'TAPSTART',
  'CHOLAMANDALAM',
  'CREDITSAISON',
  'INCRED',
  'LENDBOX',
  'ASPIRE',
  'KOMAC',
  'TRILLIONLOANS',
];

export const IMPS_ELIGIBLE_LINE_TYPES = ['CASH_LINE', 'FAST_CASH'];

export const REPAYMENT_ELIGIBLE_PARTNERS = [
  'INCRED',
  'TAPSTART',
  'CREDITSAISON',
  'DMI',
  'MUSKMELON',
  'FULLERTON',
  'HDBFS',
  'ASPIRE',
  'KOMAC',
];

export const CONFIN_ELIGIBLE_PARTNERS = ['DMI'];

export const HIDE_LSF_PARTNERS = ['CREDITSAISON', 'HDBFS'];

export const SHOW_CM_LAF_TNC_PARTNERS = [
  'CHOLAMANDALAM',
  'MUSKMELON',
  'HDBFS',
  'INCRED',
  'ASPIRE',
  'KOMAC',
  'TRILLIONLOANS',
];

export const BENEFICIARY_BANK_LIST: Record<string, string> = {
  RBL: 'ALL',
  DMI: 'ALL',
  INCRED: 'ALL',
  FULLERTON: 'ALL',
  CREDITSAISON: 'ALL',
  HDBFS: 'ALL',
  MUSKMELON: 'EMANDATE',
  DEFAULT: 'ALL',
  ASPIRE: 'ALL',
  KOMAC: 'ALL',
  TRILLIONLOANS: 'ALL',
};

export const KFS_ELIGIBLE_PARTNERS = [
  'DMI',
  'INCRED',
  'FULLERTON',
  'HDBFS',
  'CREDITSAISON',
  'MUSKMELON',
  'LENDBOX',
  'CHOLAMANDALAM',
  'ASPIRE',
  'KOMAC',
  'TRILLIONLOANS',
];
export const HOST_TO_UTM_SOURCE_MAPPING: Record<string, string> = {
  'v1.freo.money': 'mktg_sms_freo',
  'v1.moneytap.com': 'mktg_sms_mnytp',
  'v2.freo.money': 'mktg_fb_freo',
  'v2.moneytap.com': 'mktg_fb_mnytp',
  'v3.freo.money': 'mktg_gg_freo',
  'v3.moneytap.com': 'mktg_gg_mnytp',
  'v4.freo.money': 'mktg_othr_freo',
  'v4.moneytap.com': 'mktg_othr_mnytp',
  'v5.freo.money': 'mktg_mail_freo',
  'v5.moneytap.com': 'mktg_mail_mnytp',
  'v6.freo.money': 'mktg_rcs_freo',
  'v6.moneytap.com': 'mktg_rcs_mnytp',
  'v7.freo.money': 'mktg_wa_freo',
  'v7.moneytap.com': 'mktg_wa_mnytp',
  // 'qa-web.moneytap.com': 'qa-webapp-testing',
  'v8.freo.money': 'mktg_rbl_freo',
  'v8.moneytap.com': 'mktg_rbl_mnytp',
  'v9.freo.money': 'mktg_tc_freo', // TC
  'v10.freo.money': 'mktg_criteo_freo', // Criteo

  'v21.freo.money': 'mpx_pship_muthootone',

  'v31.freo.money': 'mpx_quicklend',
  'v32.freo.money': 'mpx_zet',

  'v51.freo.money': 'mpx_creditlinks',
  'v52.freo.money': 'mpx_indialends',
  'v53.freo.money': 'mpx_efundzz',
  'v54.freo.money': 'mpx_buddyloan',
  'v55.freo.money': 'mpx_kashti',
  'v56.freo.money': 'mpx_mdsmedia',
  'v57.freo.money': 'mpx_profinity',
  'v58.freo.money': 'mpx_mmm',
  'v59.freo.money': 'mpx_onecode',
  'v60.freo.money': 'mpx_bfdl',
  'v61.freo.money': 'mpx_upwards',
  'v62.freo.money': 'mpx_quid',
  'v63.freo.money': 'mpx_banksathi',
  'v64.freo.money': 'mpx_sankash',
  'v65.freo.money': 'mpx_cashkuber',
  'v66.freo.money': 'mpx_paysense',
  'v67.freo.money': 'mpx_globalline-club',
  'v68.freo.money': 'mpx_wecredit',
  'v69.freo.money': 'mpx_creditmantra',
  'v70.freo.money': 'mpx_loanwiser',
  'v71.freo.money': 'mpx_lendingkart',
  'v72.freo.money': 'mpx_fintifi',
  'v73.freo.money': 'mpx_quid',
  'v74.freo.money': 'mpx_cashe',
  'v75.freo.money': 'mpx_deeesha-edu',
  'v76.freo.money': 'mpx_mymoney-mantra',
  'v77.freo.money': 'mpx_gocredit',
  'v78.freo.money': 'mpx_bigmudra',
  'v79.freo.money': 'mpx_easemydeal',
  'v80.freo.money': 'mpx_kreditstar',
  'v81.freo.money': 'mpx_credbuddha',
  'v82.freo.money': 'mpx_paisa247',

  'v91.freo.money': 'mpx_tide',
  'v92.freo.money': 'mpx_growbizh',
  'v93.freo.money': 'mpx_infinz',
  'v94.freo.money': 'mpx_buddyloan',
  'v95.freo.money': 'mpx_marcadeo',
  'v96.freo.money': 'mpx_spectrum',
  'v97.freo.money': 'mpx_insurfin',
  'v98.freo.money': 'mpx_pixelmint', // #2773 Pixel Mint Media
  'v99.freo.money': 'mpx_mymoney-mantra', // #20090 MyMoneyMantra
  'v100.freo.money': 'mpx_mymoney-mantra', // #20090 MyMoneyMantra
  'v101.freo.money': 'mpx_mymoney-mantra', // #20090 MyMoneyMantra
  'v102.freo.money': 'mpx_mymoney-mantra', // #20090 MyMoneyMantra
  'v103.freo.money': 'mpx_mymoney-mantra', // #20090 MyMoneyMantra
  'v104.freo.money': 'mpx_mymoney-mantra', // #20090 MyMoneyMantra
  'v105.freo.money': 'mpx_pixelmint', // #20091 Pixel Mint Media
  'v106.freo.money': 'mpx_pixelmint', // #20091 Pixel Mint Media
  'v107.freo.money': 'mpx_pixelmint', // #20091 Pixel Mint Media
  'v108.freo.money': 'mpx_pixelmint', // #20091 Pixel Mint Media
  'v109.freo.money': 'mpx_pixelmint', // #20091 Pixel Mint Media
  'v110.freo.money': 'mpx_tide', // #20096 Tide
  'v111.freo.money': 'mpx_ginie', // #20096 Ginie
  'v112.freo.money': 'mpx_pixel', // #20096 Pixel Mint Media
  'v113.freo.money': 'mpx_gromo', // #20096 Gromo
  'v114.freo.money': 'mpx_loan', // #20096 Loan Associate
  'v115.freo.money': 'mpx_duit', // #20096 Duit
  'v116.freo.money': 'mpx_finwill', // #20096 Finwill
  'v117.freo.money': 'mpx_banxx', // Banxx (Creditlinks)
  'v118.freo.money': 'mpx_myfinflow', // Myfinflow
  'v119.freo.money': 'mpx_rupeeq', // Rupeeq
  'v121.freo.money': 'mpx_fintechcloud', // Fintech Cloud
  'v122.freo.money': 'mpx_firstfund', // FirstFund
  'v123.freo.money': 'mpx_neercred', // Neercred

  'v83.freo.money': 'mpx_india_lender',
  'v84.freo.money': 'mpx_bimakart',
  'v85.freo.money': 'moneytap-webqual',
  'v86.freo.money': 'mpx_credflow',
};
